
export class productAttributesController {
    attributes
    constructor(private $product, private $state) {
        "ngInject"
ٍ
    }

    $onInit() {
        this.$product.abstractAttributes({ productId: this.$state.params.pID },
            response => {
                this.attributes = response
            }
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/product-attributes/product-attributes.controller.ts